import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, ...props }) => {
  const IconComponent = icon;
  // If icon is missing or invalid, fallback to alert
  if (!IconComponent) {
    return <FiAlertTriangle {...props} />;
  }
  // Render the component
  return <IconComponent {...props} />;
};

export default SafeIcon;